// extracted by mini-css-extract-plugin
export var footer = "B";
export var footerBottom = "M";
export var footerTop = "C";
export var footerTopQrcode = "D";
export var footerTopQrcodeBox = "E";
export var footerTopQrcodeBoxImg = "F";
export var footerTopQrcodeText = "G";
export var footerTopQrcodeTextHighlight = "H";
export var footerTopRight = "I";
export var footerTopRightAddress = "L";
export var footerTopRightDescription = "K";
export var footerTopRightLogo = "J";